export default "__VITE_ASSET__CZWL9jfw__"